import type { PrizeStats as PrizeStatsType } from '@/lib/carousel-service';
import { cn } from '@/lib/utils';
import { Gift, PackageCheck, Sparkles } from 'lucide-react';

interface PrizeStatsProps {
  stats: PrizeStatsType;
  className?: string;
}

export function PrizeStats({ stats, className }: PrizeStatsProps) {
  const items = [
    {
      label: 'Kalan',
      value: stats.remaining,
      icon: Gift,
      ring: 'ring-emerald-400/25',
      glow: 'from-emerald-400/20',
      iconClass: 'bg-emerald-400/15 text-emerald-300',
      valueClass: 'text-emerald-200',
    },
    {
      label: 'Verilen',
      value: stats.given,
      icon: PackageCheck,
      ring: 'ring-sky-400/25',
      glow: 'from-sky-400/20',
      iconClass: 'bg-sky-400/15 text-sky-300',
      valueClass: 'text-sky-200',
    },
    {
      label: 'Büyük Ödül',
      value: stats.bigRemaining,
      icon: Sparkles,
      ring: 'ring-amber-400/30',
      glow: 'from-amber-400/25',
      iconClass: 'bg-amber-400/15 text-amber-300',
      valueClass: 'text-amber-200',
    },
  ];

  return (
    <div className={className ?? 'grid grid-cols-3 gap-2 sm:gap-3'}>
      {items.map((item) => (
        <div
          key={item.label}
          className={cn(
            'relative overflow-hidden rounded-2xl bg-white/[0.04] px-3 py-4 text-center ring-1 [@media(max-height:820px)]:py-3',
            item.ring
          )}
        >
          <div
            className={cn(
              'pointer-events-none absolute inset-x-0 -top-16 h-24 bg-gradient-to-b to-transparent blur-2xl',
              item.glow
            )}
          />
          <div
            className={cn(
              'relative mx-auto mb-2 flex h-9 w-9 items-center justify-center rounded-xl sm:h-10 sm:w-10',
              item.iconClass
            )}
          >
            <item.icon className="h-4 w-4 sm:h-5 sm:w-5" />
          </div>
          <div className={cn('relative text-2xl font-black tabular-nums sm:text-3xl', item.valueClass)}>
            {item.value}
          </div>
          <div className="relative mt-1 text-[11px] font-medium uppercase tracking-wider text-slate-400">
            {item.label}
          </div>
        </div>
      ))}
    </div>
  );
}
